var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEhrOrder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "#2E3438",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2043 7.67919L8.12284 10.9413L6.28536 8.89878L7.21464 8.06276L8.14527 9.09721L10.2957 6.82081L11.2043 7.67919Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.25 0.75C5.69772 0.75 5.25 1.19772 5.25 1.75L4.25 1.75C3.28351 1.75 2.5 2.53351 2.5 3.5V13.5C2.5 14.4665 3.28351 15.25 4.25 15.25H13.25C14.2165 15.25 15 14.4665 15 13.5V3.5C15 2.53351 14.2165 1.75 13.25 1.75H12.25C12.25 1.19772 11.8023 0.75 11.25 0.75H6.25ZM6.5 2V3H11V2H6.5ZM12.25 3V3.25C12.25 3.80228 11.8023 4.25 11.25 4.25H6.25C5.69772 4.25 5.25 3.80228 5.25 3.25V3H4.25C3.97453 3 3.75 3.22453 3.75 3.5V13.5C3.75 13.7755 3.97453 14 4.25 14H13.25C13.5255 14 13.75 13.7755 13.75 13.5V3.5C13.75 3.22453 13.5255 3 13.25 3H12.25Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEhrOrder);
export default __webpack_public_path__ + "static/media/ehrOrder.782a22246c7af2b3b26c2cceecc48e9f.svg";
export { ForwardRef as ReactComponent };